import React from 'react'
import { observer } from 'mobx-react-lite'

import { ListItem, ListItemText } from '@material-ui/core'

import { DropdownItemProps } from './DropdownButton'

import { useLogic } from '../hooks/storeHook'

import { AccountProps, StoreAccountModel } from '../types/accountProps'
import { useMessages } from '../hooks/snackbarHooks'
import { useDefaultMenuItemStyles } from '../hooks/defaultSelectStylesHook'

export type UnmatchProductsButtonProps<TAccount extends StoreAccountModel> =
  AccountProps<TAccount> &
  DropdownItemProps & {
  makeAccountName: (account: TAccount) => string

  onSubmit: (accountId: number) => Promise<void>
}

export const UnmatchProductsButton =
  observer(
    <TAccount extends StoreAccountModel>
    ({
       account, makeAccountName, onSubmit,
       setClosed, setLoading, setFinished
     }: UnmatchProductsButtonProps<TAccount>) => {
      const logic = useLogic()

      const {showSuccess} = useMessages()

      const accountName = makeAccountName(account)

      const menuItemClasses = useDefaultMenuItemStyles()

      const onClick = async () => {
        setClosed()

        if (!await logic.showDialog(`Будет сброшен матчинг для всех товаров на аккаунте ${accountName}!`)) {
          return
        }

        setLoading()

        try {
          await onSubmit(account.id)
          showSuccess('Матчинг товаров сброшен')
        } finally {
          setFinished()
        }
      }

      return (
        <ListItem className={menuItemClasses.menuItem} button onClick={onClick}>
          <ListItemText primary={`Сбросить ${accountName}`}/>
        </ListItem>
      )
    })